// feature/bot-litisoft — sprint90 Phase 3. Admin cockpit · Monitor en vivo.
// Reads bot_runs/bot_run_items live (5s poll): active runs with N/total progress
// + per-item status; Pausar/Detener/Reanudar write the status the worker polls
// and honors. Admin-only (route + sidebar gated).
import React, { useCallback, useEffect, useState } from "react";
import { bot } from "../../api/endpoints";
import Spinner from "../../components/Spinner";
import Empty from "../../components/Empty";
import { useToast } from "../../components/Toast";

const fmt = (d) => (d ? new Date(d).toLocaleString("es-CO") : "—");
const STATUS_COLOR = {
  requested: "var(--text-hint)", claimed: "var(--color-info)", running: "var(--color-info)",
  paused: "var(--color-warning)", done: "var(--color-success)", failed: "var(--color-danger)",
  cancelled: "var(--text-hint)",
};

export default function BotLitisoftMonitor() {
  const toast = useToast();
  const [runs, setRuns] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [detail, setDetail] = useState(null);

  const load = useCallback(() => {
    bot.runs().then((r) => setRuns(r.data.runs)).catch(() => setRuns([]));
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 5000);
    return () => clearInterval(t);
  }, [load]);

  const loadDetail = useCallback((id) => {
    bot.runDetail(id).then((r) => setDetail(r.data)).catch(() => setDetail(null));
  }, []);
  useEffect(() => {
    if (openId == null) { setDetail(null); return undefined; }
    loadDetail(openId);
    const t = setInterval(() => loadDetail(openId), 5000);
    return () => clearInterval(t);
  }, [openId, loadDetail]);

  async function control(id, action) {
    try {
      await bot.runControl(id, action);
      load();
      if (openId === id) loadDetail(id);
    } catch (err) {
      toast.push(err?.response?.data?.error || "Error", "error");
    }
  }

  const active = (runs || []).filter((r) => !["done", "cancelled", "failed"].includes(r.status));
  return (
    <div className="col" style={{ gap: 16 }}>
      <div className="muted">
        Lo que estoy haciendo ahora mismo (se actualiza cada 5 s). Puedes pausarme o detenerme
        entre casos — respeto la orden antes de empezar el siguiente. Abre una corrida para revisar
        caso por caso qué número recibió y qué falló.
      </div>
      <div className="card" style={{ padding: 0 }}>
        {runs == null ? (
          <div style={{ padding: 32, textAlign: "center" }}><Spinner size={20} /></div>
        ) : !active.length ? (
          <Empty title="No hay corridas activas" />
        ) : (
          <table>
            <thead><tr><th>#</th><th>Tipo</th><th>Estado</th><th>Progreso</th><th>Dry-run</th><th>Creada</th><th></th></tr></thead>
            <tbody>
              {active.map((r) => (
                <tr key={r.id}>
                  <td><button className="ghost sm" onClick={() => setOpenId(openId === r.id ? null : r.id)}><strong>#{r.id}</strong></button></td>
                  <td>{r.kind}</td>
                  <td><span style={{ color: STATUS_COLOR[r.status] || "inherit", fontWeight: 600 }}>{r.status}</span></td>
                  <td>{r.completed_items}/{r.total_items}</td>
                  <td>{r.dry_run ? "Sí" : "No"}</td>
                  <td className="muted" style={{ fontSize: 12 }}>{fmt(r.created_at)}</td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    {r.status === "paused"
                      ? <button className="sm" onClick={() => control(r.id, "resume")}>Reanudar</button>
                      : <button className="secondary sm" onClick={() => control(r.id, "pause")}>Pausar</button>}
                    <button className="ghost sm" style={{ color: "var(--color-danger)" }} onClick={() => control(r.id, "cancel")}>Detener</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {openId != null && detail && (
        <div className="card" style={{ padding: 0 }}>
          <div style={{ padding: "10px 16px", fontWeight: 600 }}>Corrida #{openId} — ítems</div>
          {!detail.items?.length ? (
            <Empty title="Sin ítems aún" />
          ) : (
            <table>
              <thead><tr><th>Caso</th><th>Radicado</th><th>Match</th><th>Estado</th><th>Número LITISOFT</th><th>Error</th></tr></thead>
              <tbody>
                {detail.items.map((it) => (
                  <tr key={it.id}>
                    <td>{it.case_number || "—"}</td>
                    <td style={{ fontFamily: "monospace", fontSize: 12 }}>{it.radicado}</td>
                    <td>{it.match_status}</td>
                    <td>{it.item_status}</td>
                    <td>{it.litisoft_numero || "—"}</td>
                    <td className="muted" style={{ fontSize: 12, maxWidth: 260, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={it.error_detail || ""}>{it.error_detail || ""}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
